import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ReferralsPage = lazy(() => import("./ReferralsPage.tsx"));

const HealthDiaryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ReferralsPage />
    </Suspense>
  );
};

export default HealthDiaryPageLazy;
